module.exports = __webpack_public_path__ + "media/images/icons/icon_arrow_down_blue-979e6f884458fcf16813f82b1acd200b.svg";